if (!customElements.get('image-grid')) {
  (async () => {
    const { Fancybox } = await import('@fancyapps/ui');

    customElements.define(
      'image-grid',
      class ImageGrid extends HTMLElement {
        constructor() {
          super();
          Fancybox.bind('[data-fancybox]');
        }
      }
    );
  })();
}
